import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";


import { PlannedServiceShortListComponent } from "./plannedService-short-list.component";
import { NgxPaginationModule } from "ngx-pagination";
import { PipeModule } from "app/pipes/pipe.module";

@NgModule({
  declarations: [
    PlannedServiceShortListComponent
  ],
  exports: [
    PlannedServiceShortListComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgxPaginationModule,
    PipeModule
  ]
})
export class PlannedServiceShortListModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/plannedService/list/plannedService-short-list.module.ts